import script from "./pp-ticket-check-results-addon-table.vue?vue&type=script&lang=ts&setup=true"
export * from "./pp-ticket-check-results-addon-table.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__